import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    seatDetailsOverlayContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      borderRadius: '8px',
      backgroundColor: 'white',
      padding: '0px 45px 45px 45px',
      justifyContent: 'space-around',
      boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.2)',
      width: 1160,
      height: 749,
      [theme.breakpoints.down('lg')]: {
        width: 1010
      }
    },
    seatDetailsScrollContainer: {
      height: '580px'
    },
    seatDetailsTableContainer: {
      paddingTop: '20px'
    },
    seatDetailsTableHead: {
      margin: '10px 20px 20px'
    },
    seatDetailsRow: {
      display: 'flex',
      alignItems: 'center',
      margin: '12px 36px 24px',
      borderRadius: '8px',
      boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
      backgroundColor: '#fff',
      padding: '4px 8px'
    },
    seatDetailsCell: {
      flex: '0 0 330px'
    },
    tableBodyCell: {
      whiteSpace: 'nowrap',
      overflowWrap: 'anywhere',
      background: '#ffffff00',
      flex: '1',
      fontSize: '22px',
      border: 0,
      '&:first-child': {
        marginLeft: '15px'
      }
    },
    cartRemoveCheckbox: {
      flex: '0 0 65px'
    },
    cardEventTicketColumn: {
      flex: '1 1 0%',
      background: 'transparent',
      whiteSpace: 'normal',
      lineHeight: 1.5
    },
    ticketPriceColumn: {
      paddingRight: '20px'
    },
    tableContainer: {
      width: 'calc(100% - 10px)',
      margin: '0 5px 40px'
    },
    cancelButton: {
      maxWidth: 470,
      minWidth: 450,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 460,
        minWidth: 420
      }
    },
    confirmButton: {
      maxWidth: 470,
      minWidth: 450,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 460,
        minWidth: 420
      }
    }
  })
);
